export default {
  methods: {
    isIE11() {
      return !!window.MSInputMethodContext && !!document.documentMode;
    }
  }
};
